import {
  CollapsiblePanel,
  CollapsiblePanelContent,
  CollapsiblePanelItem,
  CollapsiblePanelTrigger,
} from '../CollapsiblePanel/CollapsiblePanel';
import { PackageDetail } from '../PackageDetail/PackageDetail';
import { SheetsStack } from '../Sheets/SheetsStack';
import { PackageListProps } from './types';

export const PackageList = ({
  packages = [],
  microcopy,
  className = '',
  onOpenInUnity,
}: PackageListProps) => {
  const isSinglePackage = packages.length === 1;

  const packageListTitle = (
    <h2 className="body-bold mb-6 font-medium md:mb-8">{microcopy.title}</h2>
  );

  if (isSinglePackage) {
    const pkg = packages[0];
    return (
      <section className={className}>
        {packageListTitle}
        <PackageDetail
          name={pkg.name}
          isEntitled={pkg.isEntitled}
          description={pkg.description}
          info={pkg.info}
          compatibility={pkg.compatibility}
          microcopy={pkg.microcopy}
          onOpenInUnity={() => onOpenInUnity(pkg.id)}
        />
      </section>
    );
  }

  const mobileSheetDataWrapper = packages.map((pkg) => ({
    label: pkg.name ?? '',
    children: (
      <PackageDetail
        name={pkg.name}
        isEntitled={pkg.isEntitled}
        description={pkg.description}
        info={pkg.info}
        compatibility={pkg.compatibility}
        microcopy={pkg.microcopy}
        onOpenInUnity={() => onOpenInUnity(pkg.id)}
      />
    ),
    microcopy: { close: microcopy.close },
  }));

  return (
    <section className={className}>
      <div className="hidden md:block">
        {packageListTitle}

        <CollapsiblePanel
          type="single"
          collapsible
          className="mt-8"
          defaultValue={packages.length ? 'item-0' : undefined}
        >
          {packages.map((pkg, i) => (
            <CollapsiblePanelItem key={pkg.id} value={`item-${i}`}>
              <CollapsiblePanelTrigger>
                <h4>{pkg.name}</h4>
              </CollapsiblePanelTrigger>
              <CollapsiblePanelContent>
                <PackageDetail
                  isEntitled={pkg.isEntitled}
                  description={pkg.description}
                  info={pkg.info}
                  compatibility={pkg.compatibility}
                  microcopy={pkg.microcopy}
                  onOpenInUnity={() => onOpenInUnity(pkg.id)}
                />
              </CollapsiblePanelContent>
            </CollapsiblePanelItem>
          ))}
        </CollapsiblePanel>
      </div>

      <section className="block md:hidden">
        <SheetsStack sheets={mobileSheetDataWrapper} className="mt-8" />
      </section>
    </section>
  );
};
